import VocalBar from '@/components/organisms/VocalBar.tsx';
import { useCVTemplateContext } from '@/features/common/contexts/cv-template.context';
import { useVocalCVEditContext } from '@/features/cv/contexts/vocal-cv-edit.context.tsx';
import { getCountryCode } from '@/utils/getCountryCode.ts';

export default function VocalEditingBar() {
  const { lastMessage, currentEditingSection, currentSectionContent, startVocalEditing } =
    useVocalCVEditContext();
  const { currentLocaleCv } = useCVTemplateContext();

  // TODO: réactiver quand la modification du CV par la voix sera opérationnelle.
  // Désactivé temporairement : ne pas supprimer le code existant ci-dessous.
  return null;

  if (!currentEditingSection) {
    return null;
  }

  const onStartVocal = () => {
    if (currentEditingSection && currentSectionContent) {
      startVocalEditing(currentEditingSection, currentSectionContent);
    }
  };

  return (
    <VocalBar
      onStartVocal={onStartVocal}
      lastMessage={lastMessage}
      // Langue de la session vocale = langue du CV (choisie par le candidat).
      countryCode={getCountryCode(currentLocaleCv)}
      showFlag
      showControls
      statusCircleProps={{
        size: 40,
      }}
      flagSize={20}
    />
  );
}
